var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.available)?_c('span',{staticClass:"badge badge-pill available"},[_vm._v("Disponible")]):_c('span',{staticClass:"badge badge-pill unavailable"},[_vm._v("No disponible")])])}
var staticRenderFns = []

export { render, staticRenderFns }